import * as React from "react";
import "../../utils/number_extensions";
import { useGlobalStores } from "../../hooks/use_global_stores";
import { AutomationType, automationTypesLabels, CategoryAutomationAction, categoryAutomationLabels, IAutomation, PaymentMethodAutomationAction, paymetMethodAutomationLabels } from "../../config/automation";

interface IAutomationLabel {
    type: string;
    typeDescription: string;
    action: string;
    value: string;
}

export const useLabelProvider = () => {
    const { budgetStore, categoryStore, currencyStore, userPaymentMethodStore } = useGlobalStores();

    const getLabel = (v: IAutomation): IAutomationLabel => {
        const type = automationTypesLabels[v.type];

        let action = '';
        let typeDescription = '';
        switch (v.type) {
            case AutomationType.PAYMENT_METHOD:
                action = paymetMethodAutomationLabels[v.value.action];
                typeDescription = userPaymentMethodStore.getById(v.value.paymentMethodId)?.name || '';
                break;
            case AutomationType.CATEGORY:
                action = categoryAutomationLabels[v.value.action];
                typeDescription = categoryStore.getById(v.value.categoryId)?.name || '';
                break;
        }

        let value = '';
        switch (v.value.action) {
            case PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_FIXED:
                const amount = parseFloat(v.value.payload.amount?.toString() || '').toCurrency(currencyStore.currentCurrency, {});
                value = `${v.value.payload.name}: ${amount}`;
                break;
            case PaymentMethodAutomationAction.SHARE_WITH_FRIENDS_PERCENTAGE:
                value = `${v.value.payload.name}: ${v.value.payload.percentage}%`;
                break;
            case CategoryAutomationAction.SET_BUDGET:
                const budget = budgetStore.findBudget(v.value.payload.budget)
                value = `${budget?.name}`;
                break;
        }

        return {
            type,
            typeDescription,
            action,
            value,
        };
    };

    return { getLabel };
};
